import { useEffect, useRef } from 'react';

export default function InstallationSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const els = entry.target.querySelectorAll('.reveal');
            els.forEach((el, i) => {
              setTimeout(() => {
                el.classList.add('animate-in');
              }, i * 150);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="w-full bg-white py-16 md:py-24">
      <div className="w-full px-4 md:px-6 max-w-[1450px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="reveal opacity-0 translate-y-4 transition-all duration-700 ease-out bg-background-200 rounded-lg overflow-hidden min-h-[300px] border border-background-300/60">
            <img
              src="https://readdy.ai/api/search-image?query=Close%20up%20of%20hands%20installing%20elegant%20brass%20house%20number%20plate%20on%20modern%20wall%20with%20mounting%20hardware%20and%20distance%20spacers%2C%20DIY%20home%20improvement%20project%2C%20warm%20natural%20lighting%20with%20professional%20product%20photography%20style%2C%20showing%20screw%20and%20spacer%20detail&width=800&height=600&seq=installation-2026&orientation=landscape"
              alt="Lako postavljanje kućnih brojeva"
              className="w-full h-full min-h-[300px] object-cover rounded-lg"
            />
          </div>

          <div>
            <h2 className="reveal opacity-0 translate-y-4 transition-all duration-700 ease-out font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-6">
              LAKO POSTAVLJANJE
            </h2>
            <p className="reveal opacity-0 translate-y-4 transition-all duration-700 delay-100 ease-out text-base text-foreground-700 leading-relaxed mb-6">
              Uz brojeve dolaze distanceri, koji omogućavaju elegantno odvajanje broja od površine na 13 mm. Šraf od 6 mm prolazi kroz donji deo distancera, osiguravajući stabilnost i postojanost.
            </p>
            <ul className="reveal opacity-0 translate-y-4 transition-all duration-700 delay-200 ease-out space-y-3 mb-8">
              {[
                'Kompletan set za montažu uključen',
                'Jednostavno uputstvo za postavljanje',
                'Neophodni alati priloženi',
                'Postavljanje za manje od 10 minuta',
              ].map((item, index) => (
                <li key={index} className="flex items-center gap-3 text-sm text-foreground-700">
                  <div className="w-5 h-5 flex items-center justify-center bg-amber-100 rounded-full flex-shrink-0">
                    <i className="ri-check-line text-amber-600 text-xs" />
                  </div>
                  {item}
                </li>
              ))}
            </ul>
            <div className="reveal opacity-0 translate-y-4 transition-all duration-700 delay-300 ease-out">
              <a
                href="#"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-foreground-950 text-white font-label text-sm font-medium rounded-full hover:bg-foreground-900 transition-colors whitespace-nowrap"
              >
                Uputstvo
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .reveal.animate-in {
          opacity: 1;
          transform: translateY(0);
        }
      `}</style>
    </section>
  );
}